
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { USER_ROLES } from '../../utils/constants'; // Import roles for checking
import { getDynamicNavigationItems } from '../../components/common/Sidebar/NavigationItems';

import { Box, Grid, Card, CardContent, Typography, Button, Fade } from '@mui/material';
import { Security, People, PersonAdd } from '@mui/icons-material';
import RoleBasedWelcome from '../../components/dashboard/RoleBasedWelcome';

const Dashboard = () => {
  const navigate = useNavigate();
  const { role } = useAuth();

  // Get the first 4 accessible navigation items to use as "Quick Actions"
  const quickAccessItems = useMemo(() => getDynamicNavigationItems(role).slice(0, 4), [role]);

  return (
    <>
      {/* Role-Based Welcome Section */}
      <Box sx={{ mb: 4 }}>
        <RoleBasedWelcome />
      </Box>

      {/* Quick Actions Panel */}
      <Fade in timeout={700}>
        <Card sx={{ mb: 4, borderRadius: 2 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              Quick Actions
            </Typography>
            <Grid container spacing={2}>
              {quickAccessItems.map((item) => {
                const Icon = item.icon;
                return (
                  <Grid item xs={12} sm={6} md={3} key={item.id}>
                    <Button
                      fullWidth
                      variant="outlined"
                      startIcon={<Icon />}
                      onClick={() => navigate(item.path)}
                      sx={{ py: 1.5, justifyContent: 'flex-start' }}
                    >
                      {item.label}
                    </Button>
                  </Grid>
                );
              })}
            </Grid>
          </CardContent>
        </Card>
      </Fade>

      {/* SuperAdmin tools */}
      {role === USER_ROLES.SUPER_ADMIN && (
        <Fade in timeout={1200}>
          <Card sx={{ borderRadius: 2 }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                <Security color="warning" />
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  System Administration
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Access administrative tools and user management.
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Button variant="contained" color="warning" startIcon={<PersonAdd />} onClick={() => navigate('/users?create=1')}>
                  Add User
                </Button>
                <Button variant="outlined" color="warning" startIcon={<People />} onClick={() => navigate('/users')}>
                  Manage Users
                </Button>
                {role === USER_ROLES.SUPER_ADMIN && (
                  <Button variant="outlined" color="warning" startIcon={<Security />} onClick={() => navigate('/admin/settings')}>
                    System Settings
                  </Button>
                )}
              </Box>
            </CardContent>
          </Card>
        </Fade>
      )}
    </>
  );
};

export default Dashboard;

// import React from 'react'
// import Box from '@mui/material/Box';
// import { 
  
//   Typography, 
//   Container, 
//   Alert,
 
//   useMediaQuery,
//   Fade,

//   Grid,
//   Paper,
//   IconButton,
//   Chip,
//   Card,
//   CardContent,
//   Button
// } from '@mui/material';
// import RoleBasedWelcome from '../../components/dashboard/RoleBasedWelcome';
// import { useNavigation } from '../../hooks/useNavigation';
// import { useNavigate } from 'react-router-dom';

// import { 
//   Refresh, 
//   Dashboard as DashboardIcon,
//   Analytics,
//   TrendingUp,
//   Security,
//   People,
//   BusinessCenter
// } from '@mui/icons-material';
// import { alpha, useTheme } from '@mui/material/styles';




// function Index() {
//   const { 
//       roleInfo, 
//       user, 
//       quickAccessItems, 
//       navigationStats, 
//       canAccess 
//     } = useNavigation();
//    const navigate = useNavigate();
//  const theme = useTheme();
    
//   return (
//     <>
//       {/* Role-Based Welcome Section */}
//       <Box sx={{ mb: { xs: 3, sm: 4 } }}>
//         <RoleBasedWelcome />
//       </Box>


//        {/* Quick Access Panel */}
//         {quickAccessItems && quickAccessItems.length > 0 && (
//           <Fade in timeout={700}>
//             <Card sx={{ mb: { xs: 3, sm: 4 }, borderRadius: 3 }}>
//               <CardContent sx={{ p: 3 }}>
//                 <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
//                   Quick Actions
//                 </Typography>
//                 <Grid container spacing={2}>
//                   {quickAccessItems.slice(0, 4).map((item) => {
//                     const Icon = item.icon;
//                     const hasAccess = canAccess(item.path);
                    
//                     return (
//                       <Grid item xs={6} sm={3} key={item.id}>
//                         <Button
//                           fullWidth
//                           variant="outlined"
//                           startIcon={<Icon />}
//                           disabled={!hasAccess}
//                           onClick={() => hasAccess && navigate(item.path)}
//                           sx={{
//                             py: 1.5,
//                             justifyContent: 'flex-start',
//                             textAlign: 'left',
//                             opacity: hasAccess ? 1 : 0.5,
//                             '&:hover': {
//                               transform: hasAccess ? 'translateY(-2px)' : 'none',
//                               boxShadow: hasAccess ? 2 : 0,
//                             },
//                             transition: 'all 0.2s ease',
//                           }}
//                         >
//                           {item.label}
//                         </Button>
//                       </Grid>
//                     );
//                   })}
//                 </Grid>
//               </CardContent>
//             </Card>
//           </Fade>
//         )}



//          {/* Role-Based Feature Highlights */}
//                 {roleInfo && roleInfo.features && (
//                   <Fade in timeout={1000}>
//                     <Card sx={{ mt: 4, borderRadius: 3 }}>
//                       <CardContent sx={{ p: 3 }}>
//                         <Typography variant="h6" gutterBottom sx={{ fontWeight: 700 }}>
//                           Available Features
//                         </Typography>
//                         <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
//                           {roleInfo.features.map((feature) => (
//                             <Chip
//                               key={feature}
//                               label={feature}
//                               variant="outlined"
//                               color="primary"
//                               size="small"
//                             />
//                           ))}
//                         </Box>
                        
//                         {/* Role-specific insights */}
//                         <Box sx={{ mt: 2, p: 2, bgcolor: 'background.paper', borderRadius: 2 }}>
//                           <Typography variant="body2" color="text.secondary">
//                             <strong>Your Role:</strong> {roleInfo.label} • 
//                             <strong> Access Level:</strong> {navigationStats?.totalItems || 0} sections • 
//                             <strong> Organization:</strong> {user?.organization || 'N/A'}
//                           </Typography>
//                         </Box>
//                       </CardContent>
//                     </Card>
//                   </Fade>
//                 )}

//          {/* Admin-Only System Health Section */}
//         {canAccess('/admin') && (
//           <Fade in timeout={1200}>
//             <Card sx={{ mt: 4, borderRadius: 3, border: `1px solid ${alpha(theme.palette.warning.main, 0.3)}` }}>
//               <CardContent sx={{ p: 3 }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
//                   <Security sx={{ color: 'warning.main' }} />
//                   <Typography variant="h6" sx={{ fontWeight: 700 }}>
//                     System Administration
//                   </Typography>
//                 </Box>
//                 <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//                   You have administrative access to system settings and user management.
//                 </Typography>
//                 <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
//                   <Button
//                     variant="contained"
//                     color="warning"
//                     startIcon={<People />}
//                     onClick={() => navigate('/users')}
//                     size="small"
//                   >
//                     Manage Users
//                   </Button>
//                   <Button
//                     variant="outlined"
//                     color="warning"
//                     startIcon={<Security />}
//                     onClick={() => navigate('/admin/settings')}
//                     size="small"
//                   >
//                     System Settings
//                   </Button>
//                 </Box>
//               </CardContent>
//             </Card>
//           </Fade>
//         )}
//     </>
//   )
// }

// export default Index